import type { CreatePartnerLocationDto, UpdatePartnerLocationDto } from '../types/dto';
import type { AdminPartnerLocation } from '../types/admin';
import { baseApi, PaginatedResponse } from 'sama-shared';

export const locationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPartnerLocations: builder.query<
      PaginatedResponse<AdminPartnerLocation>,
      { partnerId?: string }
    >({
      query: ({ partnerId }) => ({
        url: '/admin/partner-location',
        method: 'GET',
        params: { partnerId },
      }),
      providesTags: (_result, _error, { partnerId }) => [
        { type: 'PartnerLocation', id: partnerId || 'LIST' },
        'AdminPartnerLocation',
      ],
    }),
    createPartnerLocation: builder.mutation<void, CreatePartnerLocationDto>({
      query: (body) => ({
        url: '/admin/partner-location',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { partnerId }) => [
        { type: 'AdminPartnerLocation', id: partnerId },
        { type: 'AdminPartnerLocation', id: partnerId },
        { type: 'Partner', id: partnerId },
        'AdminPartnerLocation',
      ],
    }),
    updatePartnerLocation: builder.mutation<void, UpdatePartnerLocationDto>({
      query: ({ id, partnerId: _, ...body }) => ({
        url: `/admin/partner-location/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, _error, { partnerId }) => [
        { type: 'AdminPartnerLocation', id: partnerId },
        { type: 'Partner', id: partnerId },
        'AdminPartnerLocation',
      ],
    }),
    deletePartnerLocation: builder.mutation<void, { id: string; partnerId: string }>({
      query: ({ id }) => ({
        url: `/admin/partner-location/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { partnerId }) => [
        { type: 'AdminPartnerLocation', id: partnerId },
        { type: 'Partner', id: partnerId },
        'AdminPartnerLocation',
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPartnerLocationsQuery,
  useCreatePartnerLocationMutation,
  useUpdatePartnerLocationMutation,
  useDeletePartnerLocationMutation,
} = locationApi;
